// WithMessagePinData.js
import { connect } from 'react-redux';

import WithMessagePinData from '../component/WithMessagePinData.jsx';

import getRemoteConfigData from '../selector/getRemoteConfigData.js';
import getListData from '../selector/getListData.js';
import getMessageData from '../selector/getMessageData.js';
import getFeedName from '../selector/getFeedName.js';
import { getSelectedQueryOptionObject } from '../selector/getFeedQueryObject.js';
import getSelectedFeedQueryOptions from '../selector/getSelectedFeedQueryOptions.js';

import { PROFILE_FEED_REMOTE_CONFIG_KEY_MAP } from '../resource/profileConstants.js';
import { QueryPrefix, QueryType } from '../resource/feedConstants.js';
import { getFeedNameType } from '../resource/feedUtils.js';

const mapStateToProps = (state, { messageId, profileListType }) => {
  const senderId = getMessageData(state, messageId, 'senderId');
  const feedRemoteConfigKey =
    PROFILE_FEED_REMOTE_CONFIG_KEY_MAP[profileListType];
  const { feedNameWithQuery } = senderId
    ? getSelectedQueryOptionObject(
        state,
        getFeedName(state, feedRemoteConfigKey, '{USER_ID}', senderId),
        getSelectedFeedQueryOptions(state, feedRemoteConfigKey, undefined),
        getRemoteConfigData(
          state,
          `${feedRemoteConfigKey}_${QueryPrefix[QueryType.SORT]}`
        )?.[0]
      )
    : {};
  return {
    messageId,
    pinnedItemIds: getListData(
      state,
      [
        'home',
        getFeedNameType({ feedName: feedNameWithQuery }),
        feedNameWithQuery,
        'pinned',
      ],
      'itemIds'
    ),
  };
};

export default connect(mapStateToProps)(WithMessagePinData);
